// extracted by mini-css-extract-plugin
export default {"wrapper":"Ov","noPadding":"Pv","flavor_wrapper":"Qv","flavor_button":"Rv","vert":"Sv","itemContent":"Tv","itemName":"Uv","blue":"Vv","out_of_stock":"Wv","newFlavorBadge":"Xv","fullWidth":"Yv","flavor_button_selected":"Zv","black":"aw","attribute_wrapper":"bw","toggle_wrapper":"cw"};
    if(module.hot) {
      // 1713996746586
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  